import React, { useEffect } from 'react';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate, useLocation } from 'react-router-dom';
import CenteredPageTitle from '../common/components/CenteredPageTitle';
import { FormInputText } from '../common/formInputs/FormInputText';
import { setCatastropheOldRequestToken, setQuestionarioOldRequestToken } from '../features/commercialReport/commercialReportActions';
import SubProductCard from '../common/components/SubProductCard';
import { generalAlertError } from '../common/utils/alerts';

export const validationsSchema = yup.object({
  vat_number: yup
    .string()
    .max(11, 'La partiva iva non puo essere piu di 11 numeri!')
    .matches(/^[0-9]*$/, 'Solo numeri sono ammessi!')
    .required('Il campo è obbligatorio. Inserisci la tua partita iva!'),
});

function Commercial() {
  const navigate = useNavigate();
  const location = useLocation();
  // const [selectedSubProduct, setSelectedSubProduct] = useState(null);
  const selectedSubProduct = null;

  // const [allowRequest, setAllowRequest] = useState(0);

  // const checkAllowRequest = async () => {
  //   const response = await managementAxe.get('/commercial/check-report-request');

  //   if (response.status !== 200) {
  //     setAllowRequest(false);
  //     return;
  //   }

  //   if (response.status === 200) {
  //     setAllowRequest(response.data.allow_request);
  //   }
  // };

  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields },
    // setValue,
    watch,
  } = useForm({
    mode: 'all',
    resolver: yupResolver(validationsSchema),
    shouldFocusError: true,
    defaultValues: {
      vat_number: '',
      sub_product: '',
    },
  });

  const commercialFormData = watch();

  const isValid = (name) => {
    if (errors[name]?.message !== undefined) {
      return false;
    }

    if (touchedFields[name] === undefined) {
      return false;
    }

    return true;
  };

  const submitForm = () => {
    if (selectedSubProduct === null) {
      generalAlertError('Seleziona un prodotto');
      return;
    }
    if (commercialFormData.vat_number === '') {
      generalAlertError('Inserisci la tua partita iva');
      return;
    }

    if (commercialFormData.sub_product === 'commercial_basic') {
      navigate(`/quote/commercial/${commercialFormData.vat_number}/report`);
    } else if (commercialFormData.sub_product === 'commercial_catastrophe') {
      // todo the page for commercial catastrophe
      navigate(`/quote/commercial/${commercialFormData.vat_number}/catastrophe`);
    }
  };

  // useEffect(() => {
  //   checkAllowRequest();
  // }, []);

  useEffect(() => {
    const callAsync = async () => {
      if (
        location.state !== null
        && location.state.commercialCompanyVatNumber !== undefined
        && location.state.sub_product !== undefined
      ) {
        navigate('/quote/quote-commercial', {
          state: {
            requestToken: location.state.requestToken,
          },
        });

        // setValue('vat_number', location.state.commercialCompanyVatNumber);
        // setValue('sub_product', location.state.sub_product);
        // setSelectedSubProduct(location.state.sub_product);
      }
    };

    callAsync();
  }, []);

  useEffect(() => {
    if (location.state !== null && location.state.requestToken !== undefined && location.state.sub_product == 'commercial_basic') {
      setQuestionarioOldRequestToken(location.state.requestToken);
    }

    if (location.state !== null && location.state.requestToken !== undefined && location.state.sub_product == 'commercial_catastrophe') {
      setCatastropheOldRequestToken(location.state.requestToken);
    }
  }, []);

  return (
    <>
      {selectedSubProduct === null && (
        <>
          <div className="quote-group">
            <div className="quote-h1 text-center">
              <h1>NUOVO PREVENTIVO</h1>
            </div>
            <div className="quote-h6">
              <h6>Cosa vuoi proteggere?</h6>
            </div>
          </div>

          <div className="container text-center select-product-one">
            <div className="row justify-content-center g-2 g-md-3 ">
              <SubProductCard
                product="GLOBAL SISTEMA"
                sub_product="IMPRESA"
                onSelect={() => {
                  navigate('/quote/quote-commercial');
                  // setSelectedSubProduct('commercial_basic');
                  // setValue('sub_product', 'commercial_basic');
                }}
              />
              {/* <SubProductCard
                product="GLOBAL SISTEMA"
                sub_product="EVENTI CATASTROFALI"
                onSelect={() => {
                  setSelectedSubProduct('commercial_catastrophe');
                  setValue('sub_product', 'commercial_catastrophe');
                }}
              /> */}
            </div>
          </div>
        </>
      )}

      {selectedSubProduct !== null && (
        <form onSubmit={handleSubmit(submitForm)}>
          <CenteredPageTitle title="Inserisci Partita IVA" />
          <div className="form-container">
            <FormInputText
              placeholder="-Partita IVA-"
              label="Partita IVA"
              registration={register('vat_number')}
              error={errors.vat_number?.message}
              valid={isValid('vat_number')}
            />
          </div>
          <div className="footer-buttons">
            <div className="d-flex justify-content-between">
              <button className="btn btn-questionnaire" type="submit">
                Continua
              </button>
            </div>
          </div>
        </form>
      )}
    </>
  );
}

export default Commercial;
